import React, { Component } from 'react';
import { Toggle, SelectButton, InfoPanel } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import RolesDropdownContainer from '../../../portal/rolesDropdownContainer';
import TextfieldFloatingText from '../../../portal/textfieldFloatingText';
import SelectTeamDialog from '../../../portal/controls/selectTeamDialog';
import styles from '../style.scss';
import { TooltipTextWrapper } from '../../../common/tooltipTextWrapper';
import MappingAttributesContainer from './mappingAttributesContainer';

@inject('translationsStore') @observer
export default class UserAuthorizationManagementContainer extends Component {

    samlStore = this.props.samlStore;
    validator = this.props.samlStore.validator;

    parseTeamName = fullPathName => {

        if(fullPathName === undefined || fullPathName === '') {

            return '';
        }

        return fullPathName.substr(1).slice(0);
    }

    onChangeDefaultRoleId = (e, index, value) => this.samlStore.setDefaultRoleId(value);

    onChangeIsMappingEnabled = e => this.samlStore.setIsMappingEnabled(e.target.checked);

    render() {
        let defaultRoleAndTeam, mappingToggle, mappingAttributes = null;
        const t = this.props.translationsStore.translate;
        const operationInProgress = this.samlStore.postSAMLIdpsProgress || this.samlStore.putSAMLIdpsProgress;
        const isManualManagement = this.samlStore.isManualManagement === false || this.samlStore.isManualManagement === 'false';

            defaultRoleAndTeam = 
                <div key='1' className={styles.samlFormRow} >
                    <RolesDropdownContainer 
                        dataCy='ddl-default-role'
                        hintText={t('DEFAULT_ROLE')}
                        floatingLabelText={<TextfieldFloatingText
                                title={t('DEFAULT_ROLE')}
                                required={false}
                            />
                        }
                        width='47%'
                        disabled={operationInProgress}
                        onChange={this.onChangeDefaultRoleId}
                        value={this.samlStore.defaultRoleId}
                        helpTooltipText={t('DEFAULT_ROLE_HELP_TOOLTIP')}
                        insertDefaultValue
                    />
                    <SelectButton
                        dataCy='select-default-team'
                        placeHolderText={<TextfieldFloatingText
                                title={t('DEFAULT_TEAM')}
                                required={this.samlStore.isManualManagement}
                            />
                        }
                        disabled={operationInProgress}
                        width='47%'
                        style={{top: '10px'}}
                        buttonText={t('SELECT')}
                        onClick={this.props.openTeamsDialog}
                        title={this.props.teamFullPathName}
                        value={this.parseTeamName(this.props.teamFullPathName)}
                        errorText={this.validator.defaultTeamIdValidationMessage}
                    />
                    <SelectTeamDialog
                        openDialog={this.props.showTeamDialog}
                        closeDialog={this.props.closeTeamsDialog}
                        onTeamSelect={this.props.onTeamSelect}
                        selectedKeys={this.props.selectedKeys}
                        onSave={this.props.teamSelected}
                        disabled={operationInProgress}
                        translations={{
                            cancelButton: t('CANCEL'),
                            headerTitle: t('SELECT_TEAM'),
                            selectTeamButton: t('SELECT_TEAM')
                        }}
                    />
                </div>;

            if(isManualManagement) {

                mappingToggle = <div key = '2'>
                                    <Toggle
                                        dataCy='tgl-enable-idp-mapping'
                                        className='enable-ldap-server'
                                        icons={false}
                                        onChange={this.onChangeIsMappingEnabled}
                                        checked={this.samlStore.isMappingEnabled}
                                        text={t('ENABLE_IDP_MAPPING')}
                                    />
                                </div>;
                
                mappingAttributes = <div key = '3'>
                                        <MappingAttributesContainer/>
                                    </div>;
            
            }
        return(
            [defaultRoleAndTeam, mappingToggle, mappingAttributes]
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/saml/addEditForm/userAuthorizationManagement/index.jsx